import { render } from "./AppFooter.vue?vue&type=template&id=21eb2c52"
const script = {}

import exportComponent from "/var/www/dashboard_viomba_com/25/public/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__